import { Box, Button, Group, Image, Modal, Stack, Text } from "@mantine/core";
import IconApprove from "assets/images/svgs/icon-approve.svg";
import IconSuccess from "assets/images/pngs/noti-success.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RoutesString from "pages/routesString";

interface Props {
  opened: boolean;
  close: () => void;
  label: string;
}

const CardDetailActionPopup = ({ opened, close, label }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const cardInfo = [
    { label: t("TRANSACTION_CODE"), value: "123456" },
    { label: t("CARD_NUMBER"), value: "32432532523523" },
    { label: t("CARD_TYPE"), value: "Debit card" },
    { label: t("TIME"), value: "12/12/2025" },
  ];

  const pinInfo = [
    { label: t("TRANSACTION_CODE"), value: "0948574365743" },
    { label: t("CARD_NUMBER"), value: "DF330035253231" },
    { label: t("TIME"), value: "12/12/2025" },
  ];

  const isLock = label === "LOCK";
  const isUnlock = label === "UNLOCK";
  const isPin = label === "PIN";
  const infoDetail = isPin ? pinInfo : cardInfo;
  let title = "";
  if (isLock) title = t("WAITING_APPROVAL_LOCK_CARD");
  else if (isUnlock) title = t("WAITING_APPROVAL_UNLOCK_CARD");
  else if (isPin) title = t("CHANGE_PIN_SUCCESS");
  const iconSrc = isPin ? IconSuccess : IconApprove;

  const handleManageRequest = () => {
    close();
    navigate(RoutesString.TransactionList);
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      withCloseButton={false}
      size={420}
      radius={16}
      padding={32}
      overlayProps={{ opacity: 0.4, blur: 2 }}
      styles={{
        body: { padding: 0 },
      }}
    >
      <Stack align="center" spacing={20} p={32}>
        {/* Icon */}
        <Box w={96} sx={{ display: "flex", justifyContent: "center" }}>
          <Image src={iconSrc} width={96} fit="contain" />
        </Box>

        {/* Title */}
        <Text fw={700} fz={18} color="#131618" ta="center">
          {title}
        </Text>

        {/* Info card */}
        <Box
          sx={{
            width: "100%",
            background: "#F5F7FA",
            borderRadius: 12,
            padding: "16px 20px",
          }}
        >
          <Stack spacing={14}>
            {infoDetail.map((item) => (
              <Group position="apart" key={item.label} noWrap>
                <Text color="#5E656B">{item.label}</Text>
                <Text fw={700} color="#2A81D0">
                  {item.value}
                </Text>
              </Group>
            ))}
          </Stack>
        </Box>

        {/* Buttons */}
        <Stack spacing={12} sx={{ width: "100%" }}>
          <Button
            fullWidth
            radius={8}
            onClick={close}
            styles={{
              root: {
                background: "#2A81D0",
                color: "#FFFFFF",
                fontWeight: 600,
                height: 44,
                "&:hover": { background: "#1F6AB5" },
              },
            }}
          >
            {t("CLOSE")}
          </Button>
          <Button
            fullWidth
            variant="outline"
            radius={8}
            onClick={handleManageRequest}
            styles={{
              root: {
                borderColor: "#2A81D0",
                color: "#2A81D0",
                fontWeight: 600,
                height: 44,
              },
            }}
          >
            {t("MANAGE_REQUEST")}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default CardDetailActionPopup;
